import { PreparedSortCriteria, SortDirection } from '@steelbuy/api-integration';
import { ListingBuyerSearchSortCriteria } from '@steelbuy/ts-shared';
import { SortCriteriaOption } from './SearchResults.enums';

export const sortCriteriaOptions = new Map<SortCriteriaOption, PreparedSortCriteria<ListingBuyerSearchSortCriteria>>([
    [
        SortCriteriaOption.RELEVANCE,
        [
            {
                property: ListingBuyerSearchSortCriteria.RELEVANCE,
                direction: SortDirection.DESCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.EXPIRES_AT_DESCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.EXPIRES_AT,
                direction: SortDirection.DESCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.EXPIRES_AT_ASCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.EXPIRES_AT,
                direction: SortDirection.ASCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.WEIGHT_DESCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.WEIGHT,
                direction: SortDirection.DESCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.WEIGHT_ASCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.WEIGHT,
                direction: SortDirection.ASCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.PRICE_ASCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.PRICE,
                direction: SortDirection.ASCENDING,
            },
        ],
    ],
    [
        SortCriteriaOption.PRICE_DESCENDING,
        [
            {
                property: ListingBuyerSearchSortCriteria.PRICE,
                direction: SortDirection.DESCENDING,
            },
        ],
    ],
]);
